// extracted by mini-css-extract-plugin
module.exports = {"ordersWrap":"Order_ordersWrap__30kMj","bottomWrap":"Order_bottomWrap__14BIg","orderFactoryWrapper":"Order_orderFactoryWrapper__1DShi","addTickets":"Order_addTickets__2HIgj"};